import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApi, useWorkspace } from '~/contexts';
import { ErrorPage } from '~/routes/public/pages';
import ProjectTaskForm from './ProjectTaskForm';
import ProjectTaskMilestoneForm from './ProjectTaskMilestoneForm';
import ProjectTaskRollupForm from './ProjectTaskRollupForm';

function ProjectTaskEditDrawer({ taskId, project, onSaved, onClose, onDelete }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const params = useParams();
  if (!taskId) taskId = params.taskId;

  const [{ isReady, task }, setTask] = useState({ isReady: false, task: null });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.www.workspaces(workspace.id).projects(project.id).tasks(taskId).get();
        setTask({ isReady: true, task: data });
      } catch {
        setTask({ isReady: true, task: null });
      }
    })();
  }, [api, workspace.id, project.id, taskId]);

  if (!isReady) return null;
  if (!task) return <ErrorPage.NotFound publicSite={false} />;

  switch (task.type) {
    case 'rollup':
      return (
        <ProjectTaskRollupForm task={task} project={project} onSaved={onSaved} onClose={onClose} onDelete={onDelete} />
      );
    case 'milestone':
      return (
        <ProjectTaskMilestoneForm
          task={task}
          project={project}
          onSaved={onSaved}
          onClose={onClose}
          onDelete={onDelete}
        />
      );
    default:
      return <ProjectTaskForm task={task} project={project} onSaved={onSaved} onClose={onClose} onDelete={onDelete} />;
  }
}

export default ProjectTaskEditDrawer;
